import {CIRContentTypes} from "./CIRContentTypes.enum";

export const globalStatic = {
  strings: {},
  endpoints: {
    highlights: {
      url: "/highlights/v1"
    },
    factoid: {
      apiUrl: "https://www.transparency.treasury.gov/services/api/fiscal_service/v1/revenue",
      fyCollectionsTotal: {
        url: "/rcm?fields=net_collections_amt,reporting_fiscal_year&filter=reporting_fiscal_year:eq:"
      },
      fyCollectionsElecCat: {
        url: "/rcm?fields=net_collections_amt,reporting_fiscal_year,electronic_category_desc&filter=reporting_fiscal_year:eq:"
      }
    }
  },
  content: {
    managed: ["FAQ"],
    contentSourceMap: {
      "File_Transmission": { contentType: CIRContentTypes.STATIC, url: "/assets/data/File_Transmission.json" },
      "About": { contentType: CIRContentTypes.STATIC, url: "/assets/data/About.json" },
      "Accessibility_Statement": { contentType: CIRContentTypes.STATIC, url: "/assets/data/Accessibility_Statement.json"},
      "Privacy_Policy": { contentType: CIRContentTypes.STATIC, url: "/assets/data/Privacy_Policy.json" },
      "Notices_Agreements": { contentType: CIRContentTypes.STATIC, url: "/assets/data/Notices_Agreements.json" },
      "Contact_Us": { contentType: CIRContentTypes.STATIC, url: "/assets/data/Contact_Us.json"},
      "FAQ": { contentType: CIRContentTypes.MANAGED, url: '' }
    },
    url: "/assets/data"
  },
  config: {
    standardDateTimeFormat: 'YYYY-MM-DDTHH:MM:SS',
    startsWithNotRoutable: ['http', '/cir/private/', '/cir/'],
  }
};
